// @flow strict

/* eslint-disable ta-code-conventions/has-matching-storydoc */
import * as React from 'react';
import { escapeHtml } from '@ta/common.text-html';

/** FAQ Answer for JSON-LD */
export type JsonLdFaqPageAnswerData = {|
  /** The answer text */
  text: string,
|};

/** FAQ Question for JSON-LD */
export type JsonLdFaqPageQuestionData = {|
  /** The question text */
  name: string,
  /** The answer for this question */
  acceptedAnswer: JsonLdFaqPageAnswerData,
|};

type JsonLdFaqPageProps = {|
  questions: Array<JsonLdFaqPageQuestionData>,
|};

/**
 * Generates the faq data into a json+ld schema for google to display our results in the google srp
 */
/* eslint-disable react/no-danger */
const FaqPageJsonLd = ({ questions }: JsonLdFaqPageProps) =>
  questions.length > 0 ? (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'FAQPage',
          mainEntity: questions.map(question => ({
            '@type': 'Question',
            name: escapeHtml(question.name),
            acceptedAnswer: {
              '@type': 'Answer',
              text: escapeHtml(question.acceptedAnswer.text),
            },
          })),
        }),
      }}
    />
  ) : null;

/* eslint-enable react/no-danger */
export default FaqPageJsonLd;
